export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: "/",
  HOME: "/home",
  ACCOUNT_SETUP: "/account-setup",
  SIGN_IN: "/sign-in",
  SIGN_OUT: "/sign-out",
  SCREENINGS: "/screenings",
  SCREENINGS_SCHEDULE: "/screenings/schedule",
  RESOURCES: "/resources",
  RESOURCE_DETAIL: "/resources/:resourceId",
  APPOINTMENTS: "/appointments",
  DOCUMENTS: "/documents",
  FAQ: "/FAQ",
  ABOUT: "/about",
  PERSONAL_INFORMATION: "/personal-information",
  COMMUNICATION_PREFERENCES: "/communication-preferences",
  CONTACT_US: "/contact-us",
  PRIVACY_POLICY: "/privacy-policy",
  TOS: "/terms-of-service",
  MASONRY_PLAYGROUND: "/masonry-playground",
  QUOTIENT_SCORE_DETAILS: "/quotient-score-details",
  PHYSICAL_RESULTS_DOWNLOAD_FORM: "/physicalResults/downloadForm",
  PHYSICAL_RESULTS_UPLOAD_FORM: "/physicalResults/uploadForm",
  LEARN_WHY_SCREENINGS_IMPORTANT: "/learn/why-screenings-important",
  LEARN_HOW_TO_SHARE_RESULTS: "/learn/how-to-share-results",
  EXPLORE: "/member/health-programs",
  CARE_LIBRARY_TOPIC: "/care-library/:tag",
  CARE_LIBRARY_SEARCH: "/member/health-programs/search",
  ADDED_BY_ME_CAMPAIGNS: "/journey/addedByMeCampaigns",
  HISTORY: "/member/health-history",
  SELF_COLLECTION_SELECT: "/self-collection",
  SELF_COLLECTION_ADDRESS_CONFIRMATION: "/self-collection/address-confirmation",
  SELF_COLLECTION_ORDER_PLACED: "/self-collection/order-placed",
  SELF_COLLECTION_CANCELLATION: "/self-collection/cancellation",
  SELF_COLLECTION_ORDER_CANCELLED: "/self-collection/order-cancelled",
  SELF_COLLECTION_INSTRUCTIONS: "/self-collection/instructions",
  SELF_COLLECTION_ACTIVATION: "/self-collection/activation",
  SELF_COLLECTION_ACTIVATION_FORM: "/self-collection/activation-form",
  SELF_COLLECTION_ACTIVATION_COMPLETE: "/self-collection/activation-complete",
};
